export var ResourceManagementGroupBy = /*#__PURE__*/ function(ResourceManagementGroupBy) {
    ResourceManagementGroupBy["Users"] = "PEOPLE";
    ResourceManagementGroupBy["Projects"] = "PROJECT";
    return ResourceManagementGroupBy;
}({});
export var ResourceType = /*#__PURE__*/ function(ResourceType) {
    ResourceType["User"] = "user";
    ResourceType["Team"] = "team";
    ResourceType["Role"] = "role";
    ResourceType["FinancialBudget"] = "financial_budget";
    return ResourceType;
}({});
export var AllocationMethod = /*#__PURE__*/ function(AllocationMethod) {
    AllocationMethod["TotalHours"] = "TOTAL";
    AllocationMethod["HoursPerDay"] = "HOURS_PER_DAY";
    AllocationMethod["PercentageOfCapacity"] = "PERCENTAGE_OF_CAPACITY";
    return AllocationMethod;
}({});
export var AllocationMedium = /*#__PURE__*/ function(AllocationMedium) {
    AllocationMedium["Soft"] = "SOFT";
    AllocationMedium["Hard"] = "HARD";
    AllocationMedium["Billable"] = "BILLABLE";
    AllocationMedium["NonBillable"] = "NON_BILLABLE";
    return AllocationMedium;
}({});
export var AllocationMediumApi = /*#__PURE__*/ function(AllocationMediumApi) {
    AllocationMediumApi["Soft"] = "soft";
    AllocationMediumApi["Hard"] = "hard";
    return AllocationMediumApi;
}({});
export var PlanningLevelConfig = /*#__PURE__*/ function(PlanningLevelConfig) {
    PlanningLevelConfig["HoursPerDay"] = "HOURS_PER_DAY";
    PlanningLevelConfig["HoursPerWeek"] = "HOURS_PER_WEEK";
    return PlanningLevelConfig;
}({});
export var ResourceManagementApiZoomType = /*#__PURE__*/ function(ResourceManagementApiZoomType) {
    ResourceManagementApiZoomType["Day"] = "DAY";
    ResourceManagementApiZoomType["Week"] = "WEEK";
    ResourceManagementApiZoomType["Month"] = "MONTH";
    return ResourceManagementApiZoomType;
}({});
export var FetchableResourceType = /*#__PURE__*/ function(FetchableResourceType) {
    FetchableResourceType["UserList"] = "userIdList";
    FetchableResourceType["RoleList"] = "roleIdList";
    FetchableResourceType["ProjectList"] = "projectIdList";
    return FetchableResourceType;
}({});
export var AllocationSourceType = /*#__PURE__*/ function(AllocationSourceType) {
    AllocationSourceType["Task"] = "TASK";
    AllocationSourceType["Phase"] = "PROJECT_PHASE";
    return AllocationSourceType;
}({});
export var RMPermissionsApiParamType = /*#__PURE__*/ function(RMPermissionsApiParamType) {
    RMPermissionsApiParamType["ResourceAI"] = "RESOURCE_AI";
    RMPermissionsApiParamType["ResourceManagement"] = "RESOURCE_MANAGEMENT";
    RMPermissionsApiParamType["TimeSheets"] = "TIME_SHEETS";
    return RMPermissionsApiParamType;
}({});
/** PEOPLE_TO_PROJECT page kind for RM Copilot preview left rail. */ export var RmPeopleToProjectRequestKind = /*#__PURE__*/ function(RmPeopleToProjectRequestKind) {
    RmPeopleToProjectRequestKind["PreviewProjects"] = "PREVIEW_PROJECTS";
    RmPeopleToProjectRequestKind["OtherProjects"] = "OTHER_PROJECTS";
    return RmPeopleToProjectRequestKind;
}({});
